import { IPrismicImage, IPrismicLink, IPrismicRichText } from './prismic';

export interface IMerch {
  imageUrl: string;
  alt: string;
  link?: IPrismicLink;
  condition?: string;
}

export interface IBannerAppSmartPrimary {
  banner_icon: IPrismicImage;
  background_color: string;
  title: IPrismicRichText;
  text: IPrismicRichText;
  button_text: string;
}

export interface IBannerAppSmart {
  primary: IBannerAppSmartPrimary;
}

export type IHeaderTopBanner = IBannerAppSmart;

export enum SLICE_TYPES {
  FRESH_ELIGIBILITY_CONFIRMATION = 'fresheligibilityconfirmation',
  FRESH_ELIGIBILITY_NOTIFICATION = 'fresheligibilitynotification',
}
